/* eslint-disable react/destructuring-assignment */
// @flow
import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid, TextField } from '@material-ui/core';
import Loading from '@common/components/Loading';
import background from '../images/7.png';
import backgroundContainer from '../images/6.png';
import logo from '../images/8.png';

class LoginBackstage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
    };
  }

  renderLoading = () => (
    <Loading />
  );

  handleLogin = () => {
    const { userStore } = this.props;

    userStore.login(this.state.username);
  };

  keyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin();
    }
  }

  render = () => {
    const { classes } = this.props;

    return (
      <div
        className={classes.container}
        style={{
          backgroundImage: `url(${backgroundContainer})`,
        }}
      >
        <Grid container className={classes.header}>
          <img alt="logo" style={{ width: 100, position: 'absolute', left: '70px' }} src={background} />
          <img alt="logo" style={{ width: 448 }} src={logo} />
        </Grid>
        <Grid
          container
          justify="center"
          alignContent="center"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <Grid
            container
            direction="column"
            justify="center"
            alignContent="center"
            spacing={4}
            className={classes.loginContainer}
          >
            <Grid
              item
              className={classes.textFieldContainer}
            >
              <TextField
                className={classes.loginTextContainer}
                fullWidth
                onKeyDown={this.keyPress}
                onChange={(e) => this.setState({ username: e.target.value })}
                id="outlined-password-input"
                placeholder="Enter your email to login"
                autoComplete="current-password"
                inputProps={{
                  style: {
                    textAlign: 'center',
                    fontFamily: "'Public Sans',sans-serif",
                    fontSize: '18px',
                  },
                }}
                variant="outlined"
                autoFocus
              />
            </Grid>
            <Grid
              item
              className={classes.loginButtonContainer}
            >
              <Button
                className={classes.loginButton}
                outline
                color="success"
                type="submit"
                onClick={this.handleLogin}
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const styles = {
  container: {
    height: '100vh',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  },
  loginContainer: {
    width: 400,
  },
  loginTextContainer: {
    background: 'white',
    width: '100%',
    textAlign: 'center',
    borderRadius: '7px',
  },
  textFieldContainer: {
    width: '360px',
    padding: '10px !important',
  },
  loginButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px !important',
  },
  loginButton: {
    height: '40px',
    width: 'auto',
    background: 'transparent',
    textTransform: 'none',
    padding: '12px 10px 14px 10px',
    color: 'white',
    fontWeight: 'bold',
    '&:hover': {
      background: 'transparent',
      border: '1px solid white',
      opacity: '0.5',
    },
    fontSize: '24px',
    fontFamily: "'Public Sans',sans-serif",
  },
  header: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    position: 'fixed',
    top: '0',
  },
};

LoginBackstage.propTypes = {
  userStore: Object,
  classes: Object,
};

export default withStyles(styles)(inject('userStore')(observer(LoginBackstage)));
